import { render, staticRenderFns } from "./SingleClientDocuments.vue?vue&type=template&id=3fa2975a&"
import script from "./SingleClientDocuments.vue?vue&type=script&lang=js&"
export * from "./SingleClientDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports